import { createContext, useState, useContext } from "react";
import Loader from "../components/shared/loader";
import CryptidLoading from "../components/shared/cryptidLoading";

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [cryptidLoading, setCryptidLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading, setCryptidLoading}}>
      {isLoading &&  <Loader fullscreen="true" />}
      {cryptidLoading && <CryptidLoading fullscreen="true"/>}
      {children}
    </LoadingContext.Provider>
  );
};
